@if (length > 1) {
  <div class="nav-buttons">
    <button mat-button (click)="onPrevious()" [disabled]="index === 0" data-testid = 'PREVIOUS.BUTTON'>
      {{ 'BUTTON.PREVIOUS' | translate }}
    </button>
    <span>{{ index + 1 }} {{ 'OF' | translate }} {{ length }}</span>
    <button mat-button (click)="onNext()" [disabled]="index >= length - 1" data-testid = 'NEXT.BUTTON'>
      {{ 'BUTTON.NEXT' | translate }}
    </button>
  </div>
}
